import {gql} from '@apollo/client';

export const CreateRace = gql`
    mutation CreateRace($raceName: String, $raceDescription: String) {
        createRace(raceName: $raceName, raceDescription: $raceDescription) {
            raceId
            raceName
        }
    }
`

export const UpdateRace = gql`
    mutation UpdateRace($raceName: String, $raceId: Int, $raceDescription: String) {
        updateRace(raceName: $raceName, raceId: $raceId, raceDescription: $raceDescription) {
            raceDescription
            raceName
        }
    }
`

export const DeleteRace = gql`
    mutation DeleteRace($raceId: Int!) {
        deleteRace(raceId: $raceId)
    }
`

export const CreateSubrace = gql`
    mutation CreateSubrace($raceId: Int!, $subraceDescription: String, $subraceName: String) {
        createSubrace(raceId: $raceId, subraceDescription: $subraceDescription, subraceName: $subraceName) {
            subraceId
            subraceName
        }
    }
`

export const UpdateSubrace = gql`
    mutation Mutation($subraceId: Int!, $raceId: Int!, $subraceName: String, $subraceDescription: String) {
        updateSubrace(subraceId: $subraceId, raceId: $raceId, subraceName: $subraceName, subraceDescription: $subraceDescription) {
            subraceId
            subraceName
        }
    }
`

export const DeleteSubrace = gql`
    mutation DeleteSubrace($subraceId: Int!) {
        deleteSubrace(subraceId: $subraceId)
    }

`

export const CreateClass = gql`
    mutation CreateClass($className: String, $classDescription: String, $classSpellCast: String, $hitdie: Int, $subclassLevel: Int) {
        createClass(className: $className, classDescription: $classDescription, classSpellCast: $classSpellCast, hitdie: $hitdie, subclassLevel: $subclassLevel) {
            classId
            className
            classDescription
        }
    }
`

export const UpdateClass = gql`
    mutation UpdateClass($classId: Int!, $className: String, $classDescription: String, $classSpellCast: String, $hitdie: Int, $subclassLevel: Int) {
        updateClass(classId: $classId, className: $className, classDescription: $classDescription, classSpellCast: $classSpellCast, hitdie: $hitdie, subclassLevel: $subclassLevel) {
            classId
            className
        }
    }
`

export const DeleteClass = gql`
    mutation DeleteClass($classId: Int!) {
        deleteClass(classId: $classId)
    }
`

export const CreateSubclass = gql`
    mutation CreateSubclass($classId: Int, $subClassSpellCast: String, $subclassDescription: String, $subclassName: String) {
        createSubclass(classId: $classId, subClassSpellCast: $subClassSpellCast, subclassDescription: $subclassDescription, subclassName: $subclassName) {
            subclassName
            subclassId
            subclassDescription
            subClassSpellCast
        }
    }
`

export const UpdateSubclass = gql`
    mutation UpdateSubclass($subclassId: Int!, $subclassName: String, $subclassDescription: String, $subClassSpellCast: String, $classId: Int) {
        updateSubclass(subclassId: $subclassId, subclassName: $subclassName, subclassDescription: $subclassDescription, subClassSpellCast: $subClassSpellCast, classId: $classId) {
            subclassId
            subclassName
        }
    }
`

export const DeleteSubclass = gql`
    mutation Mutation($subclassId: Int!) {
        deleteSubclass(subclassId: $subclassId)
    }
`

export const CreateMana = gql`
    mutation CreateMana($referenceId: Int!, $manaAmount: Int, $manaLevel: Int, $manaCantrips: Int, $manaMaxSpells: Int, $manaMaxSpellLevel: Int, $isClass: Boolean) {
        createMana(referenceId: $referenceId, manaAmount: $manaAmount, manaLevel: $manaLevel, manaCantrips: $manaCantrips, manaMaxSpells: $manaMaxSpells, manaMaxSpellLevel: $manaMaxSpellLevel, isClass: $isClass) {
            manaId
        }
    }
`

export const UpdateMana = gql`
    mutation UpdateMana($manaId: Int!, $referenceId: Int!, $manaAmount: Int, $manaLevel: Int, $manaCantrips: Int, $manaMaxSpells: Int, $manaMaxSpellsLevel: Int, $isClass: Boolean) {
        updateMana(manaId: $manaId, referenceId: $referenceId, manaAmount: $manaAmount, manaLevel: $manaLevel, manaCantrips: $manaCantrips, manaMaxSpells: $manaMaxSpells, manaMaxSpellsLevel: $manaMaxSpellsLevel, isClass: $isClass) {
            manaId
        }
    }
`

export const DeleteMana = gql`
    mutation DeleteMana($manaId: Int!) {
        deleteMana(manaId: $manaId)
    }

`

export const CreateClassFeature = gql`
    mutation CreateClassFeature($classId: Int!, $classFeatureName: String, $classFeatureDesc: String, $onLevel: Int) {
        createClassFeature(classFeatureDesc: $classFeatureDesc, classFeatureName: $classFeatureName, classId: $classId, onLevel: $onLevel) {
            classFeatureId
            classFeatureName
            classFeatureDesc
            onLevel
        }
    }
`

export const UpdateClassFeature = gql`
    mutation UpdateClassFeature($classId: Int!, $classFeatureName: String, $classFeatureDesc: String, $onLevel: Int, $classFeatureId: Int!) {
        updateClassFeature(classFeatureDesc: $classFeatureDesc, classFeatureName: $classFeatureName, classId: $classId, onLevel: $onLevel, classFeatureId: $classFeatureId) {
            classFeatureId
            classFeatureName
            classFeatureDesc
            onLevel
        }
    }
`

export const DeleteClassFeature = gql`
    mutation DeleteClassFeature($classFeatureId: Int!) {
        deleteClassFeature(classFeatureId: $classFeatureId)
    }
`

export const CreateSubclassFeature = gql`
    mutation CreateSubclassFeature($subclassId: Int!, $subclassFeatureName: String, $subclassFeatureDesc: String, $onLevel: Int) {
        createSubclassFeature(subclassFeatureDesc: $subclassFeatureDesc, subclassFeatureName: $subclassFeatureName, subclassId: $subclassId, onLevel: $onLevel) {
            subclassFeatureId
            subclassFeatureName
            subclassFeatureDesc
            onLevel
        }
    }
`

export const UpdateSubclassFeature = gql`
    mutation UpdateSubclassFeature($subclassFeatureId: Int!, $subclassId: Int, $subclassFeatureName: String, $subclassFeatureDesc: String, $onLevel: Int) {
        updateSubclassFeature(subclassFeatureId: $subclassFeatureId, subclassId: $subclassId, subclassFeatureName: $subclassFeatureName, subclassFeatureDesc: $subclassFeatureDesc, onLevel: $onLevel) {
            subclassFeatureId
            subclassFeatureName
            subclassFeatureDesc
            onLevel
        }
    }
`

export const DeleteSubclassFeature = gql`
    mutation DeleteSubclassFeature($subclassFeatureId: Int!) {
        deleteSubclassFeature(subclassFeatureId: $subclassFeatureId)
    }
`

export const CreateRaceFeature = gql`
    mutation CreateRaceFeature($raceFeatureName: String, $raceFeatureDesc: String, $raceId: Int!) {
        createRaceFeature(raceFeatureDesc: $raceFeatureDesc, raceFeatureName: $raceFeatureName, raceId: $raceId) {
            raceId
            raceDescription
            raceName
            raceFeatures {
                raceFeatureId
                raceFeatureName
                raceFeatureDesc
            }
        }
    }
`

export const UpdateRaceFeature = gql`
    mutation UpdateRaceFeature($raceFeatureId: Int!, $raceFeatureName: String, $raceFeatureDesc: String) {
        updateRaceFeature(raceFeatureName: $raceFeatureName, raceFeatureDesc: $raceFeatureDesc, raceFeatureId: $raceFeatureId) {
            raceFeatureId
        }
    }
`

export const DeleteRaceFeature = gql`
    mutation DeleteRaceFeature($raceFeatureId: Int!) {
        deleteRaceFeature(raceFeatureId: $raceFeatureId)
    }
`

export const CreateSubraceFeature = gql`
    mutation CreateSubraceFeature($subraceFeatureName: String, $subraceFeatureDesc: String, $subraceId: Int!) {
        createSubraceFeature(subraceFeatureDesc: $subraceFeatureDesc, subraceFeatureName: $subraceFeatureName, subraceId: $subraceId) {
            subraceId
            subraceName
            subraceDescription
            subraceFeatures {
                subraceFeatureDesc
                subraceFeatureId
                subraceFeatureId
            }
            Race {
                raceId
                raceName
            }
        }
    }
`

export const UpdateSubraceFeature = gql`
    mutation UpdateSubraceFeature($subraceFeatureId: Int!, $subraceFeatureName: String, $subraceFeatureDesc: String) {
        updateSubraceFeature(subraceFeatureId: $subraceFeatureId, subraceFeatureName: $subraceFeatureName, subraceFeatureDesc: $subraceFeatureDesc) {
            subraceFeatureId
        }
    }
`

export const DeleteSubraceFeature = gql`
    mutation DeleteSubraceFeature($subraceFeatureId: Int!) {
        deleteSubraceFeature(subraceFeatureId: $subraceFeatureId)
    }
`